import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StatusBadge } from "@/components/shared/status-badge";
import { EmptyState } from "@/components/shared/empty-state";
import { postApiExecutions } from "@/lib/api/generated/workflows/workflows";
import { formatTimestamp, truncateId } from "@/lib/utils/formatting";
import { useDocumentTitle } from "@/lib/hooks/use-document-title";
import { useTenantContext } from "@/lib/hooks/use-tenant-context";

export function TenantActivityPage() {
  const { tenantId } = useTenantContext();
  const { data: executions } = useQuery({
    queryKey: ["executions", tenantId],
    queryFn: () => postApiExecutions({ tenantId: tenantId! }),
    enabled: Boolean(tenantId),
  });
  useDocumentTitle("Activity");

  const recentExecutions = executions
    ? [...executions].toSorted((a, b) => b.startedAt.localeCompare(a.startedAt)).slice(0, 10)
    : [];

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Recent Executions</CardTitle>
        </CardHeader>
        <CardContent>
          {recentExecutions.length === 0 ? (
            <EmptyState title="No executions" description="Workflow executions for this tenant will appear here." />
          ) : (
            <div className="border border-border rounded-[var(--radius-sm)] overflow-hidden">
              <table className="w-full text-xs">
                <thead>
                  <tr style={{ background: "var(--bg-accent)" }}>
                    <th className="text-left px-3 py-2 font-medium" style={{ color: "var(--muted-foreground)" }}>Execution ID</th>
                    <th className="text-left px-3 py-2 font-medium" style={{ color: "var(--muted-foreground)" }}>Workflow</th>
                    <th className="text-left px-3 py-2 font-medium" style={{ color: "var(--muted-foreground)" }}>Status</th>
                    <th className="text-right px-3 py-2 font-medium" style={{ color: "var(--muted-foreground)" }}>Started</th>
                  </tr>
                </thead>
                <tbody>
                  {recentExecutions.map((exec) => (
                    <tr key={exec.executionId} className="border-t border-border">
                      <td className="px-3 py-2 font-mono" style={{ color: "var(--text-strong)" }}>
                        {truncateId(exec.executionId)}
                      </td>
                      <td className="px-3 py-2">{exec.workflowKey}</td>
                      <td className="px-3 py-2"><StatusBadge status={exec.status} /></td>
                      <td className="px-3 py-2 text-right" style={{ color: "var(--muted-foreground)" }}>
                        {formatTimestamp(exec.startedAt)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>

    </div>
  );
}
